export const MAIN_CONTACT = 'MAIN_CONTACT_';